import React, { useEffect, useState } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios'

const UpdateStatusModal = (props) => {
  const userId = localStorage.getItem("user_id");

  const {
    requestId,
    newStatus,
    apiUrl,
    danger,
    onUpdated,
    onCancel,
  } = props;

  const [updating, setUpdating] = useState(false);

  useEffect(() => setUpdating(false), []);

  const handleAbandon = () => {
    setUpdating(true);

    axios.put(`${apiUrl}/request/${requestId}`, {
      user_id: userId,
      payload: {
        status: newStatus,
      },
    }).then(onUpdated).finally(() => {
      setUpdating(false);
    });
  }

  const { show, title, bodyText } = props;

  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bodyText}
      </Modal.Body>
      <Modal.Footer>
        <Button variant={danger ? "danger" : "primary"} disabled={updating} onClick={handleAbandon}>
          OK
        </Button>
        <Button variant="secondary" disabled={updating} onClick={onCancel}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

export default UpdateStatusModal;
